import { defaultConfig } from 'app/config/environment';
import axios from 'axios';

// Crear una instancia de axios específica para sincro que no use la URL base global
const sincroAxios = axios.create({
  baseURL: defaultConfig.BASE_URL_, // Usa la URL base sin /api
});

const JOB_SINCRO = 'sif-sync/v2/jobs/{job_id}';

export function getJobSincro(jobId, token) {
  return sincroAxios.get(JOB_SINCRO.replace('{job_id}', jobId), {
    headers: {
      Authorization: token,
    },
  });
}
